/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
export const amazonInfo = {
  contactCenter: 'Amazon',
  contactCenterNoteName: 'Amazon Web Services'
};

export const niceInfo = {
  contactCenter: 'NICE CXone',
  contactCenterNoteName: 'NICE CXone'
};

export const subscriptionType = {
  AMAZON_CONNECT: 'amazon_connect',
  AMAZON_CONNECT_SUBSCRIBE: 'amazonConnect',
  NICE_CXONE: 'nice_cxone',
  NICE_CXONE_SUBSCRIBE: 'nicecxone',
  GENESYS_AUDIO_CONNECTOR: 'genesys_audio_connector',
  GENESYS_AUDIO_CONNECTOR_SUBSCRIBE: 'genesysAudioConnector'
};
